import { $regraEntidade, $regraAcao } from '@/custom-enum/regras-enum.js'
import { getUserData } from "@/auth/utils";
import helpers from "@/helpers/index";

export const gerarRotasDinamicas = () => {
  let rotas = [];
  const userData = getUserData();

  if (userData?.menu_lateral_dinamico) {
    const dados = userData.menu_lateral_dinamico

    dados.forEach((modulo) => {
      modulo.children.forEach((child) => {
        rotas.push({
          path: helpers.retornaRoutePathPorModulo(modulo.key, child.route),
          name: helpers.retornaRouteNamePorModulo(modulo.key, child.key),
          meta: {
            resource: $regraEntidade.rotas.protegida,
            subject: helpers.retornaRouteRulePorModulo(modulo.key, child.key),
            action: $regraAcao.visualizar,
            layout: 'normal',
            title: modulo.title + ' - ' + child.title,
            moduloKey: modulo.key,
            componenteKey: child.key
          },
          component: () => import('@/views/pages/power-bi/PainelGenerico.vue'),
        });
      });
    });
  }

  return rotas;
}
